


import { Component, Vue } from 'vue-property-decorator';
import { PopupModule } from '../../common-admin/store/modules/popup';
import { DataModal, Jobs, JobsResponse } from '~/interfaces/weather.interface';
import { NotificationsModule } from '~common/store/modules/notifications';
import apiService from '~/services/api.service';


@Component({
    components: {},
})
export default class WeatherExtract extends Vue {

    dataGetFromBack = [] as JobsResponse[];
    dataModal: DataModal = {
        selectedExportType: 'Country list',
        location: {
            bbox: {
                east: 0,
                north: 0,
                south: 0,
                west: 0,
            },
            countries: [],
        },
        modulesSelected: [],
        datesSelected: [],
        error: '',

    };

    jobToDelete = '';
    nbrClickOnJobToDelete = 0;


    get ColorByState() {
        return {
            pending: 'orange',
            quoted: 'orange',
            ongoing: 'green',
            completed: 'green',
            canceled: 'red',
            failed: 'red',
            outdated: 'red',
        };
    }


    get headers() {
        return [
            {
                text: 'Id',
                sortable: false,
                value: 'id',
                align: 'start',
            },
            {
                text: 'Creation date',
                sortable: true,
                value: 'date',
                align: 'start',
            },
            {
                text: 'Location',
                sortable: false,
                value: 'location',
                align: 'start',
            },
            {
                text: 'Period',
                sortable: false,
                value: 'period',
                align: 'start',
            },
            {
                text: 'Module types',
                sortable: false,
                value: 'module_types',
                align: 'start',
            },
            {
                text: 'Status',
                sortable: true,
                value: 'state',
                align: 'start',
            },
            {
                text: 'Quote result',
                sortable: false,
                value: 'quote',
                align: 'start',
            },
            {
                text: 'Actions',
                sortable: false,
                value: 'actions',
                align: 'start',
            },
        ];
    }

    get items() {
        const regionNames = new (Intl as any).DisplayNames(['en'], { type: 'region' });
        return this.dataGetFromBack.map((item) => {
            const { location } = item.export_parameters;
            return {
                id: item.id,
                date: item.created_at,
                location: location?.bbox ? JSON.stringify(location.bbox) : location?.countries ? location?.countries.map((country) => regionNames.of(country)).join(', ') : '',
                period: `${this.splitDate(item.export_parameters.start)} - ${this.splitDate(item.export_parameters.stop)}`,
                module_types: item.export_parameters.module_types.join(', '),
                state: item.state.toLowerCase(),
                results: item.results,
                progress: item.progress ? item.progress > 99 ? 99 : item.progress : 0,
                quote: item.quote,
            };
        });
    }

    splitDate(date: string) {
        return date.split('T')[0];
    }

    formatFileToDownload(data: string[]) {
        let isCountry = false;
        const dataFormated = data.map(url => {
            const regex = /[A-Z]{2}-\d{4}-\d{2}/;
            const regexZone = /zone-\d{4}-\d{2}/;
            const matchCountry = url.match(regex);
            const matchZone = url.match(regexZone);
            if (matchCountry) {
                isCountry = true;
                const country = matchCountry[0].split('-')[0];
                const date = matchCountry[0].split(country + '-')[1];
                return {
                    country,
                    date,
                    url,
                };
            } else if (matchZone) {
                isCountry = false;
                const date = matchZone[0].split('zone-')[1];
                return {
                    date,
                    url,
                };
            }
        });
        const header = isCountry ? 'country,date,url\n' : 'date,url\n';
        const csv = dataFormated.map(row => {
            if (row) {
                return Object.values(row).join(',');
            }
        }).join('\n');
        const csvFile = new Blob([header, csv], { type: 'text/csv' });
        const csvUrl = URL.createObjectURL(csvFile);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = csvUrl;
        hiddenElement.target = '_blank';
        hiddenElement.download = 'weather-extract.csv';
        hiddenElement.click();

    }

    showNewQuoteOrExport() {
        this.dataModal.error = '';
        PopupModule.setPopupRequested('weather-extract');
    }

    async startExport(id: string) {
        await apiService.startweatherextractjob({ job_id: id });
        window.location.reload();
    }

    async startQuote(id: string) {
        await apiService.startweatherquotejob({ job_id: id });
        window.location.reload();
    }

    async cancelExport(id: string) {
        await apiService.cancelWeatherExtractJob({ job_id: id });
        window.location.reload();
    }

    async deleteExport(id: string) {

        if (this.jobToDelete === id && this.nbrClickOnJobToDelete === 1) {
            this.jobToDelete = '';
            this.nbrClickOnJobToDelete = 0;
            await apiService.deleteWeatherExtractJob({ job_id: id });
            window.location.reload();
        } else {
            this.jobToDelete = id;
            this.nbrClickOnJobToDelete++;
            NotificationsModule.pushNotification({
                title: 'Confirm delete job',
                text: 'Are you sure you want to delete this job? Please click again to confirm',
                type: 'warning',
                duration: 5000,
            });
        }
    }

    async copyTheLink(item: Jobs) {
        if (!item.results) {
            NotificationsModule.pushNotification({
                title: 'No link available',
                text: 'There is no link available for this job',
                type: 'error',
                duration: 5000,
            });
            return;
        }
        const dateNow = new Date();
        dateNow.setDate(dateNow.getDate() - 1);
        const expirationDate = new Date(item.results.expiration_date);

        if (dateNow > expirationDate) {
            NotificationsModule.pushNotification({
                title: 'Expired link',
                text: 'The link is expired, please regenerate it',
                type: 'error',
                duration: 5000,
            });
        } else {
            this.formatFileToDownload(item.results.links);
            NotificationsModule.pushNotification({
                title: 'File downloaded',
                text: 'The file with your links has been downloaded',
                type: 'success',
                duration: 5000,
            });
        }
    }

    checkIfAllSelected(data: DataModal) {
        if (data.selectedExportType === 'Country list' && data.location.countries && data.location.countries.length === 0) {
            throw new Error('Please select at least one country');
        } else if (data.selectedExportType === 'zones' && data.location.bbox && Object.values(data.location.bbox).some(value => value === 0)) {
            throw new Error('Please fill all zone fields');
        } else if (data.modulesSelected.length === 0) {
            throw new Error('Please select at least one module');
        } else if (data.datesSelected.length < 2) {
            throw new Error('Please select the range of dates');
        }
    }

    async createNewJob() {
        try {
            this.checkIfAllSelected(this.dataModal);
            const body = {
                start: this.dataModal.datesSelected[0],
                stop: this.dataModal.datesSelected[1],
                module_types: this.dataModal.modulesSelected,
                location: {},
            };
            if (this.dataModal.selectedExportType === 'Country list') {
                body.location = {
                    countries: this.dataModal.location.countries,
                };
            } else {
                // convert bbox to float

                for (const coord in this.dataModal.location.bbox) {
                    // @ts-ignore
                    this.dataModal.location.bbox[coord] = parseFloat(this.dataModal.location.bbox[coord]);
                }

                body.location = {
                    bbox: this.dataModal.location.bbox,
                };
            }
            await apiService.createWeatherExtractJob(body);
            PopupModule.setPopupInactive();
            window.location.reload();
        } catch (e: any) {
            this.dataModal.error = e.message;
        }
    }

    async created() {
        const result = await apiService.getWeatherExtractJobs();
        this.dataGetFromBack = result.data;
    }


}


